import React, { useState, ChangeEvent, FormEvent, useEffect } from "react";

import EnvolvementThumbnail from "../appComponents/explorePage/EnvolvementThumbnail";

const Hero = () => (
  <section
    id="product"
    className="md:px-20 px-6 sm:px-12 py-4 pt-12 flex md:flex-row flex-col md:gap-16 gap-12 justify-center items-center"
  >
    <div className="md:w-2/3 flex justify-center items-center flex-col text-center">
      <h2 className={styles.heading2}>Engage Your Audience</h2>
      <p className={`${styles.paragraph} max-w-[470px] mt-5`}>
        Monetize your audience through unique interactive opportunities
      </p>
      <WaitlistButton />
    </div>

    <div className="md:w-1/3 w-5/6">
      <EnvolvementCarousel />
    </div>
  </section>
);

const WaitlistButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleClick = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div className="pt-8">
      <button
        className="bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-white text-lg font-semibold py-3 px-8 rounded-lg shadow-md hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
        onClick={handleClick}
      >
        Apply to Waitlist
      </button>
      <div
        className={`${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2"
        } transition-opacity duration-500 transform mt-4`}
      >
        <EmailForm />
      </div>
    </div>
  );
};

const envolvements = [
  {
    _id: "1",
    title: "Watercolor Workshop",
    imgUrl: "https://i.imgur.com/XttPzFm.jpeg",
    username: "MiniM",
    userPicture: "https://i.imgur.com/d6NLo4O.png",
    price: { price: 49.99, free: false },
    categories: ["Art", "Workshop"],
    previewText:
      "Next Tuesday, join me for a guided workshop on my watercolor techniques.",
    endDate: {
      endDate: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString(),
      none: false,
    },
    quantity: { unlimited: false, quantity: 15, currentEnvolves: 0 },
    datePublished: "2024-07-05T12:00:00.000Z",
    description:
      "Next Tuesday, join me for a guided workshop on my watercolor techniques.",
  },
  {
    _id: "2",
    title: "Include Your NPC In This Upcoming Session!",
    imgUrl: "https://i.imgur.com/k403PMP.png3",
    username: "RPGDaniel",
    userPicture: "https://i.imgur.com/jr94KIr.png",
    price: { price: 29.99, free: false },
    categories: ["Gaming", "TTRPG"],
    previewText:
      "Send in your OC during our next live-streamed session from the King Feller campaign.",
    endDate: {
      endDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
      none: false,
    },
    quantity: { unlimited: false, quantity: 7, currentEnvolves: 0 },
    datePublished: "2024-07-05T12:00:00.000Z",
    description:
      "Send in your OC during our next live-streamed session from the King Feller campaign.",
  },
  {
    _id: "3",
    title: "Your Effects On The Discord Soundbar",
    imgUrl: "https://i.imgur.com/7yOIXWY.pngY",
    username: "FXRZane",
    userPicture: "https://i.imgur.com/062yye0.png",
    price: { price: 4.99, free: false },
    categories: ["Audio", "Stream Alert"],
    previewText:
      "Send your best sound and I’ll use it as a stream alert this week.",
    endDate: {
      endDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
      none: false,
    },
    quantity: { unlimited: false, quantity: 20, currentEnvolves: 0 },
    datePublished: "2024-07-05T12:00:00.000Z",
    description:
      "Send your best sound and I’ll use it as a stream alert this week.",
  },
  {
    _id: "4",
    title: "Your Signature On The Subscriber Wall!",
    imgUrl: "https://i.imgur.com/jaj6Ef7.jpeg",
    username: "Starr",
    userPicture: "https://i.imgur.com/UO1q1XE.png",
    price: { price: 2.99, free: false },
    categories: ["Community", "Subscriber Wall"],
    previewText:
      "Become part of my growing subscriber wall, updates every stream!",
    endDate: {
      endDate: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString(),
      none: false,
    },
    quantity: { unlimited: true, quantity: 0, currentEnvolves: 0 },
    datePublished: "2024-07-05T12:00:00.000Z",
    description:
      "Become part of my growing subscriber wall, updates every stream!",
  },
  {
    _id: "5",
    title: "Ask A Question For Next Week’s Q&A",
    imgUrl: "https://i.imgur.com/xVf8u6x.png",
    username: "JohnBoySpots",
    userPicture: "https://i.imgur.com/aZdYlFp.png",
    price: { price: 6.99, free: false },
    categories: ["Q&A", "Photography"],
    previewText:
      "Ask your photography-related questions and I will answer them :)",
    endDate: {
      endDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
      none: false,
    },
    quantity: { unlimited: false, quantity: 30, currentEnvolves: 0 },
    datePublished: "2024-07-05T12:00:00.000Z",
    description:
      "Ask your photography-related questions and I will answer them :)",
  },
];

const EnvolvementCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === envolvements.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  return (
    <div className="w-full mx-auto relative">
      <div className="overflow-hidden relative">
        <div
          className="flex transition-transform duration-500 ease-in-out"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {envolvements.map((envolvement, index) => (
            <div key={index} className="w-full flex-shrink-0">
              <EnvolvementThumbnail data={envolvement} />
            </div>
          ))}
        </div>
      </div>
      <div className="flex justify-center mt-4">
        {envolvements.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full mx-1 ${
              currentIndex === index ? "bg-primary-500" : "bg-gray-300"
            }`}
          ></button>
        ))}
      </div>
    </div>
  );
};

const EmailForm = () => {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log("Submitted email:", email);
    setEmail("");
    setIsSubmitted(true);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  if (isSubmitted) {
    return (
      <div className="font-poppins font-normal text-primary-300 text-[20px] leading-[30.8px]">
        Thank you!
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      <label
        htmlFor="email"
        className="block mb-2 text-sm font-medium text-white"
      >
        Email Address:
      </label>
      <input
        type="email"
        id="email"
        value={email}
        onChange={handleChange}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Enter your email"
        required
      />
      <button
        type="submit"
        className="text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
      >
        Submit
      </button>
    </form>
  );
};

const styles = {
  boxWidth: "xl:max-w-[1280px] w-full",

  heading2:
    "font-poppins font-semibold xs:text-[48px] text-[40px] text-white xs:leading-[76.8px] leading-[66.8px]",
  paragraph:
    "font-poppins font-normal text-primary-300 text-[20px] leading-[30.8px]",

  flexCenter: "flex justify-center items-center",
  flexStart: "flex justify-center items-start",

  paddingX: "sm:px-16 px-6",
  paddingY: "sm:py-16 py-6",
  padding: "sm:px-16 px-6 sm:py-12 py-4",

  marginX: "sm:mx-16 mx-6",
  marginY: "sm:my-16 my-6",
};

export const layout = {
  section: `flex md:flex-row flex-col ${styles.paddingY}`,
  sectionReverse: `flex md:flex-row flex-col-reverse ${styles.paddingY}`,

  sectionImgReverse: `flex ${styles.flexCenter}`,
  sectionImg: `flex-1 flex ${styles.flexCenter} md:ml-10 ml-0 md:mt-0 mt-10 relative`,

  sectionInfo: `flex-1 ${styles.flexStart} flex-col`,
};

export default Hero;
